import React from "react";
import { PageProps, graphql } from "gatsby";
import LastScrollCTA from "@components/StrapiComponents/LastScrollCTA";
import WebinarPoints from "@components/webinar/WebinarPoints";
import WebinarHero from "@components/webinar/Hero";
import ContentWrapper from "@components/common/Base/ContentWrapper";
import FactBlock from "@components/webinar/FactBlock";
import { WhitePaperPageDataModel } from "@models/whitepaper";
import RelatedWhitePapers from "@components/whitepaper/RelatedWhitepapers";
import Layout from "@components/common/Layout";

const WhitePaper = (props: PageProps<WhitePaperPageDataModel>) => {
  const { data, path } = props ?? {};
  const {
    lastScrollCTA,
    author,
    whitepaperPoints,
    factBlock,
    title,
    relatedWhitepapers,
  } = data?.strapiWhitepaper ?? {};

  return (
    <Layout>
      <div>
        <WebinarHero
          bigHeader={title}
          ctaLink={lastScrollCTA?.ctaLink}
          ctaText="READ WHITEPAPER"
          path={path}
        />
        <FactBlock componentData={factBlock} />
        <ContentWrapper>
          <WebinarPoints
            authors={author}
            webinarPointsData={whitepaperPoints}
            speakerWriterHeader="Author"
          />
        </ContentWrapper>
        <LastScrollCTA componentData={lastScrollCTA} />
        <RelatedWhitePapers
          componentData={{
            title: relatedWhitepapers.title,
            whitepapers: relatedWhitepapers.webinars,
          }}
        />
      </div>
    </Layout>
  );
};

export default WhitePaper;

export const query = graphql`
  query strapiWhitepaper($slug: String, $formName: String) {
    strapiWhitepaper(slug: { eq: $slug }) {
      id
      slug
      lastScrollCTA {
        id
        innerHtml
        ctaText
        ctaLink
        variant
      }
      title
      author {
        firstName
        lastName
        subTitle
        about
      }
      factBlock {
        bgColor
        title
        subTitle
        statTwoTitle
        statTwoDescription
        statOneTitle
        statOneDescription
      }
      author {
        ...author
      }
      whitepaperPoints {
        id
        title
        points {
          id
          title
          subTitle
          icon
        }
      }
      relatedWhitepapers {
        title
        webinars {
          title
          learnMoreText
          learnMoreLink
          id
          image {
            localFile {
              childImageSharp {
                gatsbyImageData(width: 307, quality: 100)
              }
            }
          }
        }
      }
      # whitepapers {
      #   id
      #   title
      #   slug
      #   image {
      #     localFile {
      #       childImageSharp {
      #         gatsbyImageData(
      #           height: 158
      #           width: 307
      #           placeholder: NONE
      #           quality: 100
      #         )
      #       }
      #     }
      #   }
      # }
    }
    hubspotForm(name: { eq: $formName }) {
      id
      guid
      portalId
      submitText
      formFieldGroups {
        default
        fields {
          name
          label
          type
          fieldType
          description
          groupName
          displayOrder
          required
          enabled
          hidden
          defaultValue
          isSmartField
          unselectedLabel
          placeholder
          labelHidden
          propertyObjectType
          objectTypeId
          options {
            label
            value
          }
        }
      }
    }
  }
`;
